module.exports = __webpack_public_path__ + "media/images/btn-contact-12203773a9ba4fa9e557a94b972e2855.svg";